// PDFAsImage.js
import React, { useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import workerSrc from 'pdfjs-dist/build/pdf.worker.entry';

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

const PDFAsImage = ({ file }) => {
    const containerRef = useRef(null);
    const [numPages, setNumPages] = useState(null);

    const onLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <div className="pdf-wrapper">
            <div className="pdf-image-view" ref={containerRef}>
                <Document file={file} onLoadSuccess={onLoadSuccess}>
                    {numPages &&
                        Array.from(new Array(numPages), (_, index) => (
                            <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                loading={null}
                                width={window.innerWidth}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                            />
                        ))}
                </Document>
            </div>
        </div>
    );
};

export default PDFAsImage;
